import { notFound } from 'next/navigation'
import { ApiError } from '@/utility/apiClient'

/**
 * APIエラーハンドリング共通関数
 * SSR: GET系404はnotFound()をコール
 * CSR: errorをthrowし、各コンポーネントのcatchでgetStatusCode()により処理
 */
export function handleApiError(error: any, method: string = 'GET'): never {
  if (
    typeof window === 'undefined' &&
    error instanceof ApiError &&
    error.status === 404 &&
    method.toUpperCase() === 'GET'
  )
    notFound()

  throw error
}
